'use strict'

/**
 *
 * @name: nnNotificationsList
 *
 */

// import mockedNotifications from './mocked-notifications.js' // for testing notifications

import DirectiveTemplate from './nn-notifications-list.directive.html'
import './nn-notifications-list.directive.scss'

function NnNotificationsListDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: {
      notifications: '=*',
      theme: '=*' // large
    },
    template: DirectiveTemplate,
    controller: DirectiveController
  }
}

function DirectiveController (
  // $scope
) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */

  // $scope.mockedNotifications = mockedNotifications; // for testing notifications


  /*
   *
   * @PUBLIC
   *
   */


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */
}

export default NnNotificationsListDirective



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-notifications-list/nn-notifications-list.directive.js